import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import V2App from './v2/App';
import { isV2Path } from './v2/constants/path';
import store from './store';
import v2Store from './v2/store';
import { Provider } from 'react-redux';

import * as serviceWorker from './serviceWorker';
import BitkeyPlatformAPI from './utils/bitkey-platform-api';
import { bkpPath } from './config/baseConfig';
import { Datadog } from './monitoring/datadog';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';

Datadog.startMonitoring();

const theme = createMuiTheme({
  typography: {
    fontFamily: ['Lato', 'Noto Sans CJK JP'].join(','),
    subtitle1: {
      fontSize: '18px',
      fontWeight: 500
    },
    h1: {
      fontWeight: 'bold'
    },
    body1: {
      fontSize: '14px'
    }
  },
  palette: {
    primary: {
      main: '#03A9F4'
    }
  },
  overrides: {
    MuiPickersDay: {
      daySelected: {
        color: 'white'
      },
      current: {
        color: 'black'
      }
    }
  }
});

const isV2 = isV2Path(window.location.pathname);

BitkeyPlatformAPI.init(bkpPath, {
  header: {
    serviceName: 'homehub',
    clientKind: 'bitlock-og-entry-service',
    version: isV2 ? 'v2' : 'v1'
  }
});

ReactDOM.render(
  <Provider store={isV2 ? v2Store : store}>
    <ThemeProvider theme={theme}>{isV2 ? <V2App /> : <App />}</ThemeProvider>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
